<template>
    <main class="main franchise" id="main">
        <franchiseNav></franchiseNav>
        <div class="top_line" id="restaurant_form">
            <div class="container">
              <!--h1>Почему тысячи людей заказывают на ХОЧУ-ПОЕСТЬ?</h1-->
              <h1>Единственный актуальный бизнес. Начни уже через 2 дня!</h1>
            </div>
        </div>

        <section class="section s-join_form">
            <div class="container">
                <div class="restaurant_form">
                    <div class="main_form_box">
                        <div class="form_title">
                            <!--h1>ВЗНОС - 25000. РОЯЛТИ - 0.ЕЖЕМЕСЯЧНО - 4650 РУБ</h1-->
                          <h1>Специальная цена на взнос до конца месяца всего – 55 000 руб</h1>
                          <h2 style="margin-top:2%; color:red;">ВНИМАНИЕ! ВЛАСТИ МОСКВЫ 100% КОМПЕНСИРУЮТ ЗАТРАТЫ НА ПОКУПКУ ФРАНШИЗЫ</h2>
                        </div>

                        <div class="input_order">
                            <input type="text" name="" class="order" v-model="name" required>
                            <div class="placeholder">
                                Ваше имя <span>*</span>
                            </div>
                        </div>

                        <div class="input_order">
                            <input type="text" name="" class="order" v-model="city.name" required>

                            <div class="placeholder">
                                Город <span>*</span>
                            </div>
                        </div>

                        <div class="input_order">
                            <input type="text" name="" class="order" v-model="phone" data-inputmask="'mask': '+9(999)999-99-99'" required>

                            <div class="placeholder">
                                +7(__)__-__-__ <span>*</span>
                            </div>
                        </div>

                        <div class="input_order">
                            <input type="text" name="" class="order" v-model="email" required>

                            <div class="placeholder">
                                user@domain.com <span>*</span>
                            </div>
                        </div>

                    </div>

                    <div class="info_agreement">
                        <input type="checkbox" name="" id="post" v-model="checkbox">
                        <label for="post" id="info_label"></label>
                        Я принимаю <span class="link">условия пользовательского соглашения</span>
                    </div>

                    <button class="menu_item_btn" @click="sendOffer">УЗНАТЬ КАК</button>
                </div>

            </div>
        </section>

        <!---------s franchise------------->

        <section class="section s-about_franchise">
            <div class="container">
                <div class="franchise">
                  <!--h1>ЧТО МЫ ДЕЛАЕМ</h1-->
                  <h1>БИЗНЕС КОТОРЫЙ В КРИЗИС НАЧАТЬ ПРОЩЕ ВСЕГО</h1>
                    <div class="about_box">
                      <!--p>Мы развиваем такое популярное и быстрорастущее направление как заказ еды
                        через сайт агрегатор. Совершенно не важно, какая численность населения
                        города и сколько в нем ресторанов. За счет технологий нашей платформы
                        делаем заказ простым и удобным, помогаем выбирать вкусную еду в два клика.
                        Привлекаем посетителей бонусными деньгами, акциями и подарками. </p>
                      <p>Предпринимателям (как начинающим, так и состоявшимся) мы предлагаем партнерство
                        основанное на современных IT технологиях, когда зарабатывать можно действительно
                        большие деньги, а управлять бизнесом из дома не нанимая десятки сотрудников.
                        Да! Именно так выглядит современный бизнес. </p-->
                      <p>Полноценный бизнес, который Вы начинаете через 2 дня, окупаете через неделю и начинаете зарабатывать сейчас и получаете готовый работающий прибыльный бизнес после кризиса и окончания карантина.</p>
                      <p>Сейчас мы столкнулись со сложной ситуацией, когда бизнесы закрываются и терпят колоссальные убытки.</p>
                      <p>Агрегатор хочу-поесть.рф – не просто продолжает работу, а выходит на более высокий уровень показывая кратный рост.</p>
                      <p>Присоединяйтесь к нам прямо сейчас. Сейчас то время, когда количество заказов растет просто само по себе. Зарабатывайте!</p>
                    </div>
                    <h1> ВОТ ТАК ВЫ ВИДИТЕ, СКОЛЬКО ВЫ ЗАРАБАТЫВАЕТЕ</h1>
                    <div class="earnings_box">
                        <div class="col">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/table.png" alt="">
                        </div>
                        <div class="col">
                            <div class="col_item">
                                <h2>ВСЕГДА СТРЕМИТЕСЬ К БОЛЬШЕМУ!</h2>
                                <p>Вы можете смотреть статистику заказов в других городах и пообщаться с
                                    коллегами, которые достигают лучших результатов, узнать как они это
                                    делают и взять на вооружение их "фишки". </p>
                                <p>Всё автоматизировано. Для партнера и для ресторана. </p>
                            </div>
                            <div class="col_item">
                                <h2>ФАКТЫ И ЦИФРЫ</h2>
                                <p>Многомиллиардный рынок доставки еды растет и развивается.
                                    Как посчитать количество заказов доставки еды?</p>
                                <p>Минимум 1 заказ в год приходится на 1 жителя Вашего города.
                                    В Вашем городе проживает 100 000 человек. Средняя стоимость заказа во втором
                                    полугодии выросла до 1207 рублей </p>
                                <p>Соответственно, рынок доставки еды Вашего города можно оценить в
                                    размере 120 700 000 рублей. И этот рынок растет </p>
                                <p>Рестораны платят комиссию от 10%, то есть, как минимум 12 070 000 рублей </p>
                            </div>
                        </div>
                        <div class="col full">
                            <div class="col_item">
                                <p>Пока еще у Вас есть уникальная возможность захватить этот рынок и начать получать
                                    прибыль уже со второго месяца работы в не зависимости от численности населения Вашего
                                    города. Чем больше город, тем больше объем рынка. Маленький город – невысокий,
                                    но стабильный доход!</p>
                                <p>Конечно, в первые месяцы Вы не сможете забрать всех клиентов. Но мы уже к этому идем.
                                    Свяжитесь с нашим отделом маркетинга! Наши специалисты помогут плавно и методично
                                    занять рынок.</p>
                                <p>Ни один другой интернет-ресурс по доставке еды не предоставляет возможности работать
                                    по франшизе и это объяснимо. Многомиллионный рынок они захватывают самостоятельно,
                                    но намного дольше и вкладывают гораздо больше денег. Мы же нацелены на партнерство,
                                    поскольку убедились в том, что региональный представитель в своем городе способен
                                    добиться гораздо больших успехов, за короткие сроки и при минимальных вложениях.</p>
                                <h3>Сколько людей живет в Вашем городе?</h3>
                                <h3>А теперь посчитайте, всего 300 заказов в день = 1 000 000 чистой прибыли!</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!---------Tendencies ------------->

        <section class="section s-tendency">
            <div class="container">
              <div class="tendency_box">
                <h1>ТЕНДЕНЦИИ РЫНКА</h1>

                <div class="tendency_item">
                  <iframe src="https://www.youtube.com/embed/O3WcQmR_7Y4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

                <div class="tendency_item">
                  <iframe src="https://www.youtube.com/embed/LtKQdEgCol8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

                <div class="tendency_item">
                  <iframe src="https://www.youtube.com/embed/Rnc6Pu0cFtk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

                <div class="tendency_item">
                  <iframe src="https://www.youtube.com/embed/PWzA6dMKEyo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

                <div class="tendency_item">
                  <iframe src="https://www.youtube.com/embed/K7t9MK6W6Kw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

                <div class="tendency_item">
                  <iframe src="https://www.youtube.com/embed/-YsGcnL0tUo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
            </div>
        </section>

        <section class="section s-questions">
            <div class="container">
                <div class="questions_box">
                    <div class="title">
                        <h1> ПОКА ЕЩЕ У ВАС ЕСТЬ ВОЗМОЖНОСТЬ ПОЛУЧИТЬ ЭТУ ФРАНШИЗУ...<br>
                            В ОДНОМ ГОРОДЕ ТОЛЬКО ОДИН ПАРТНЕР</h1>
                        <h3>Вопрос - Ответ</h3>
                    </div>
                    <div class="question"  data-collapse="#question_1">
                        <div class="item">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
                            <h2>Я правильно понимаю что модель бизнеса в том, что мне не нужно ничего готовить и
                                самому возить-доставлять? </h2>
                        </div>

                        <p id="question_1">Все считается автоматически. Вы в любой день и время можете зайти в
                            Ваш личный кабинет и посмотреть сколько каких ресторанов получили заказов и какой
                            процент должны Вам выплатить. </p>
                    </div>
                    <div class="question"  data-collapse="#question_1">
                        <div class="item">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
                            <h2>Что делать если ресторан в конце месяца мне не заплатит?</h2>
                        </div>

                        <p id="question_1">Все считается автоматически. Вы в любой день и время можете зайти в
                            Ваш личный кабинет и посмотреть сколько каких ресторанов получили заказов и какой
                            процент должны Вам выплатить. </p>
                    </div>
                    <div class="question"  data-collapse="#question_1">
                        <div class="item">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
                            <h2>А как мне считать сколько % я должен получить от разных заказов и разных ресторанов?</h2>
                        </div>

                        <p id="question_1">Все считается автоматически. Вы в любой день и время можете зайти в
                            Ваш личный кабинет и посмотреть сколько каких ресторанов получили заказов и какой
                            процент должны Вам выплатить. </p>
                    </div>
                    <div class="question"  data-collapse="#question_1">
                        <div class="item">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
                            <h2>Получается, что все что от меня нужно для начала бизнеса это
                                просто заключить договоры, потом иногда работать над продвижением
                                проекта в городе и все?</h2>
                        </div>

                        <p id="question_1">Все считается автоматически. Вы в любой день и время можете зайти в
                            Ваш личный кабинет и посмотреть сколько каких ресторанов получили заказов и какой
                            процент должны Вам выплатить. </p>
                    </div>
                    <div class="question"  data-collapse="#question_1">
                        <div class="item">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
                            <h2>У меня нет ИП и ООО и открывать не хочу. Как то сможем с Вами сотрудничать?</h2>
                        </div>

                        <p id="question_1">Все считается автоматически. Вы в любой день и время можете зайти в
                            Ваш личный кабинет и посмотреть сколько каких ресторанов получили заказов и какой
                            процент должны Вам выплатить. </p>
                    </div>
                    <div class="question"  data-collapse="#question_1">
                        <div class="item">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
                            <h2>Хотел бы открыться сразу в нескольких городах так как не вижу
                                препятствий ведь все равно все происходит через интернет кроме
                                первых поездок по ресторанам</h2>
                        </div>

                        <p id="question_1">Все считается автоматически. Вы в любой день и время можете зайти в
                            Ваш личный кабинет и посмотреть сколько каких ресторанов получили заказов и какой
                            процент должны Вам выплатить. </p>
                    </div>
                    <div class="question"  data-collapse="#question_1">
                        <div class="item">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
                            <h2>У большинства тех кто сейчас занимается доставкой уже есть свои сайты. Зачем им еще сотрудничать с нами?</h2>
                        </div>

                        <p id="question_1">Все считается автоматически. Вы в любой день и время можете зайти в
                            Ваш личный кабинет и посмотреть сколько каких ресторанов получили заказов и какой
                            процент должны Вам выплатить. </p>
                    </div>
                    <div class="question"  data-collapse="#question_1">
                        <div class="item">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
                            <h2>У нас в нашем маленьком городе очень мало служб доставки.
                                Пара пиццерий, несколько доставок суши и пироги. Есть смысл мне начинать работу?</h2>
                        </div>

                        <p id="question_1">Все считается автоматически. Вы в любой день и время можете зайти в
                            Ваш личный кабинет и посмотреть сколько каких ресторанов получили заказов и какой
                            процент должны Вам выплатить. </p>
                    </div>
                    <div class="question"  data-collapse="#question_1">
                        <div class="item">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
                            <h2>В нашем городе уже есть несколько аналогичных сайтов доставки еды. Есть ли смысл открываться и конкурировать с ними?</h2>
                        </div>

                        <p id="question_1">Все считается автоматически. Вы в любой день и время можете зайти в
                            Ваш личный кабинет и посмотреть сколько каких ресторанов получили заказов и какой
                            процент должны Вам выплатить. </p>
                    </div>
                    <div class="question"  data-collapse="#question_1">
                        <div class="item">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
                            <h2>Были в ресторане, ответили , что уже работают с двумя такими же
                                как мы сайтами. Деливери клаб, в том числе. И от этого сотрудничества
                                особо они ничего не имеют, 1-2 % от оборота</h2>
                        </div>

                        <p id="question_1">Все считается автоматически. Вы в любой день и время можете зайти в
                            Ваш личный кабинет и посмотреть сколько каких ресторанов получили заказов и какой
                            процент должны Вам выплатить. </p>
                    </div>
                    <div class="question"  data-collapse="#question_1">
                        <div class="item">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
                            <h2>Поскольку данный бизнес является бизнесом онлайн (т.е. без границ) я
                                бы не хотел останавливаться на одном своем городе. Не вижу препятствий
                                работать сразу в нескольких городах даже не в своем регионе
                                (к тому же, у мен много знакомых и друзей в других городах которые могут
                                мне помочь). Возможно ли это? Нет ли привязки к месту жительства? </h2>
                        </div>

                        <p id="question_1">Все считается автоматически. Вы в любой день и время можете зайти в
                            Ваш личный кабинет и посмотреть сколько каких ресторанов получили заказов и какой
                            процент должны Вам выплатить. </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="section s-hp_team">
            <div class="container">
                <h1>НАША КОМАНДА</h1>
                <div class="team_box">
                    <div class="team_item">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/command2.png" alt="Евгений">
                        <div class="person_description">
                            <h2>Евгений</h2>
                            <p>владелец агрегатора доставки еды ХОЧУ-ПОЕСТЬ</p>
                        </div>
                    </div>
                    <div class="team_item">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/command3.png" alt="Ольга">
                        <div class="person_description">
                            <h2>Ольга</h2>
                            <p>руководитель отдела маркетинга агрегатора доставки еды ХОЧУ-ПОЕСТЬ</p>
                        </div>
                    </div>
                    <div class="team_item">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/command4.png" alt="Александр">
                        <div class="person_description">
                            <h2>Александр</h2>
                            <p>финансовый консультант агрегатора доставки еды ХОЧУ-ПОЕСТЬ</p>
                        </div>
                    </div>
                    <div class="team_item">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/command5.png" alt="Никита">
                        <div class="person_description">
                            <h2>Никита</h2>
                            <p>SMM-специалист агрегатора доставки еды ХОЧУ-ПОЕСТЬ</p>
                        </div>
                    </div>
                    <div class="team_item">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/command6.png" alt="Павел">
                        <div class="person_description">
                            <h2>Павел</h2>
                            <p>дизайнер агрегатора доставки еды ХОЧУ-ПОЕСТЬ</p>
                        </div>
                    </div>
                    <div class="team_item">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/stacy.png" alt="Анастасия">
                        <div class="person_description">
                            <h2>Анастасия</h2>
                            <p>пресс-секретарь агрегатора доставки еды ХОЧУ-ПОЕСТЬ</p>
                        </div>
                    </div>
                    <div class="team_item">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/karina.png" alt="Карина">
                        <div class="person_description">
                            <h2>Карина</h2>
                            <p>блоггер агрегатора доставки еды ХОЧУ-ПОЕСТЬ</p>
                        </div>
                    </div>
                    <div class="team_item">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/command9.png" alt="Александр">
                        <div class="person_description">
                            <h2>Александр</h2>
                            <p>IT-специалист агрегатора доставки еды ХОЧУ-ПОЕСТЬ</p>
                        </div>
                    </div>
                    <div class="team_item">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/command10.png" alt="">
                        <div class="person_description">
                            <h2>Валентина</h2>
                            <p>менеджер поддержки франчайзи агрегатора доставки еды ХОЧУ-ПОЕСТЬ</p>
                        </div>
                    </div>
                </div>
                <!--div class="smi_box">
                    <h1>СМИ О НАС</h1>
                    <div class="smi_items">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/smi_1.svg" alt="">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/smi_2.svg" alt="">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/smi_3.svg" alt="">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/smi_4.svg" alt="">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/smi_5.svg" alt="">
                    </div>
                </div-->
            </div>
        </section>

        <div class="bottom_line">
            <img class="bg" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/bottom_line.png" alt="" style="max-height: 90px;object-fit: fill;">
            <div class="container">
                <div class="contacts_box">
                    <div class="text">
                        <p></p>
                    </div>

                    <div class="text middle">
                        <p>Viber / WhatsApp <span>+7 938 1 444 265</span></p>
                    </div>
                    <div class="send_box">
                        <span>pr@hochu-poest.com</span>
                        <button class="menu_item_btn green" onclick="document.location+='#restaurant_form';return false;" >НАПИСАТЬ</button>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import franchiseNav from '@/components/franchiseNav'
import axios from '@/router/http'
import Inputmask from 'inputmask'
export default {
  name: 'franchise',
  props: ['city', 'auth', 'geo', 'user'],
  components: {franchiseNav},
  data () {
    return {
      name: null,
      phone: null,
      email: null,
      checkbox: null
    }
  },
  created () {
    $('[data-collapse]').on('click', function (event) {
      event.preventDefault()
      let $this = $(this)
      $this.toggleClass('active')
    })
    Inputmask().remove(document.getElementById('input'))
    setTimeout(() => { Inputmask().mask(document.querySelectorAll('input')) }, 500)
  },
  methods: {
    sendOffer () {
      this.errors = []
      if (!this.name) alert('Необходимо указать имя')
      else if (!this.phone) alert('Необходимо указать телефон')
      else if (!this.email) alert('Необходимо указать почту')
      else if (!this.checkbox) alert('Вам необходимо принять пользовательское соглашение')
      else {
        setTimeout(function () { alert('Ваша заявка отправлена, в ближайшее время мы с Вами свяжемся') }, 1)
        var formData = new FormData()
        formData.append('crm', '7')
        formData.append('pipe', '13')
        formData.append('lead[102]', 'Хочу Поесть + Россия (ru)')
        formData.append('lead[103]', this.city.name)
        formData.append('note', 'Заявка на франшизу')
        formData.append('contact[name]', this.name)
        formData.append('contact[100]', this.phone)
        formData.append('contact[101]', this.email)
        formData.append('contact[106]', this.city.name)
        formData.append('contact[107]', 'Хочу Поесть + Россия (ru)')
        axios.post('https://franch.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/franchise.vue